import BaseComponent from "@js/components/base_component.jsx";

import MuiUserSettingsForm from "@js/components/mui/user_settings/form.jsx";

class MuiUserSettingsShow extends BaseComponent {
  render() {
    return <MuiUserSettingsForm { ...this.props } editing={ false } />;
  }
}

export default MuiUserSettingsShow;
